import React from 'react'

export default function FutureMineralPricesChartLoading() {
  return <div className="border-muted-300 bg-muted-300 col-span-12 h-full animate-pulse border-2 p-2 lg:col-span-9" />
}
